import React from 'react';
export function AboutHero() {
  return <section className="bg-ink py-20 text-center px-4" data-id="element-460">
      <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-461">
        Meet the Storm Coaching Team
      </h1>
      <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-462">
        Experienced, passionate, and dedicated to helping every student reach
        their full potential.
      </p>
    </section>;
}